export const withTransaction = (diagram: go.Diagram, callback: () => void, name?: string) => {
  const transactionName = name || 'transaction';
  diagram.startTransaction(transactionName);
  callback();
  diagram.commitTransaction(transactionName);
};
